<template>
  <v-card flat class="loader-box-wrapper pa-2" :class="{ 'absolute': absolute }">
    <v-progress-circular indeterminate :size="40" color="primary" />
  </v-card>
</template>

<script>
export default {
  props: {
    absolute: { type: Boolean, required: false, default: false }
  }
}
</script>

<style lang="scss" scoped>
  .loader-box-wrapper {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, .75);
    z-index: 2;
    &.absolute {
      position: absolute;
    }
  }
</style>
